import { Tooltip } from '@lmn/design-system';
import React from 'react';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { Icon } from '@/app/common/icons/Icon';
import { AddToComparisonContainer } from '../styled';

type Props = {
  open?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: React.ReactElement<any> | string;
  tooltipSx: React.CSSProperties;
  handleClick: (e: React.MouseEvent) => void;
  isSelected: boolean;
  isPromo: boolean;
  isPromoButton: boolean;
};

const ComparisonTooltip = ({ open, content, tooltipSx, handleClick, isSelected, isPromo, isPromoButton }: Props) => {
  const { localization } = usePageWrapperData();

  return (
    <AddToComparisonContainer
      onClick={handleClick}
      isSelected={isSelected}
      localization={localization}
      isPromo={isPromo}
      isPromoButton={isPromoButton}
    >
      <Tooltip content={content} open={open} placement="top" disablePortal={true} tooltipSx={tooltipSx}>
        {/* A span, because the tooltip trigger needs an element that takes a ref and its handlers.
            It also keeps the long-press image menu off the button. */}
        <span css="display: flex;" onContextMenu={(e) => e.preventDefault()}>
          <Icon
            category="Semantics"
            name={isSelected ? 'icon-check' : 'icon-circle-plus'}
            size={24}
            color={isSelected ? 'iconPrimaryDefault' : 'iconOnDark'}
          />
        </span>
      </Tooltip>
    </AddToComparisonContainer>
  );
};

export default ComparisonTooltip;
